import { render, staticRenderFns } from "./ChecklistStudent.vue?vue&type=template&id=b1632402&scoped=true&"
import script from "./ChecklistStudent.vue?vue&type=script&lang=js&"
export * from "./ChecklistStudent.vue?vue&type=script&lang=js&"
import style0 from "./ChecklistStudent.vue?vue&type=style&index=0&id=b1632402&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1632402",
  null
  
)

export default component.exports